export default {
    login: "Login",
    logout: "Logout",
    home: "Home",
    editProfile: "Edit Profile"
}